import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useDiagnosticsStyles = makeStyles({
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },

  infoButton: {
    color: designTokens.neutral[400],
    cursor: "pointer",
    padding: "0",
    minWidth: "unset",
    background: "none",
    border: "none",
    display: "inline-flex",
    ":hover": {
      color: designTokens.neutral[600],
    },
    ":focus-visible": {
      outline: `2px solid ${designTokens.accent[500]}`,
      outlineOffset: "2px",
    },
  },
});
